import React, { useMemo } from 'react'
import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'
import { useParams } from 'react-router-dom'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'
import { HitMapComponent, MapRow } from '@/components/Map/HitMap'

import './HitMap.css'
import { useTranslations } from '@/hooks/useTranslations'
import { MachinePath } from './Common'
import { Machine } from '@/services/model/machine'
import { HitMapNav, HitMapNavData, HitMapNavURLParams, hitsMap } from '../HitMap'
import { getTodayRange } from '@/common/time'
import { Spinner } from '@/components/spinner'

export const CommunalMachineHitsMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const machineId = useParams().mid
  const [rows, setRows] = useState<MapRow[] | undefined>(undefined)
  const translates = useTranslations(services, session)
  const [machine, setMachine] = useState<Machine>()
  const [navData, setNavData] = useState<HitMapNavData>({
    range: getTodayRange(),
    hitLvl: 'all',
    machinePoint: '',
    username: '',
    hitRange: hitsMap.all
  })

  useEffect(() => {
    setMachine(undefined)
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  useEffect(() => {
    services.session.fetchWithToken(`/api/communal/machines/byid/${machineId}/hits/map?${HitMapNavURLParams(navData)}`).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        console.error(erros)
        return Promise.reject<MapRow[]>()
      }
      const resp: MapRow[] = await r.json()
      setRows(resp)
    })
  }, [navData])

  if (!machine || !translates ) {
    return <Spinner />
  }

  return <MainPageLayout pageName='machine-hitmap' services={services} translates={translates} session={session}
    path={[...MachinePath({ session, translates, machine }), {
      title: translates.for(`page.communal-machine-hitmap.title`)
    }]}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>

    <HitMapNav session={session} services={services} data={navData} setter={setNavData} fieldMatrix={{
      range: true,
      username: true,
      machineName: false
    }}/>

    <HitMapComponent rows={rows} services={services} session={session} />
  </MainPageLayout>
}
